import { AppState } from '../../reducers/appreducer/appreducer.types';
import { THEME_COLORS } from './themeprovider.constant';

export const getTheme = (selectedTheme: AppState['selectedTheme'] = 'light'): { [key: string]: any } => {
  return THEME_COLORS[selectedTheme];
};
